import { DropdownMenu, Text } from '@cashfree-intl/coherent';
import styled from 'styled-components';

export const StyledDropdownMenu = styled(DropdownMenu)`
  &.visible.menu.transition {
    &::-webkit-scrollbar {
      display: block !important;
      width: ${props => props.theme.SCROLL_BAR_WIDTH.small};

      &-track {
        border-radius: 100vw;
        margin-block: 0.8rem;
        margin-block-end: 2.8rem;
      }
      &-thumb {
        background: var--(SECONDARY_LIGHTER);
      }
    }
  }
`;

export const StyledKbd = styled.kbd`
  font-size: 0.625rem;
  display: inline-block;
  border: 1px solid var(--SECONDARY_LIGHTER);
  border-radius: 0.25rem;
  padding: 0.125rem 0.375rem;
  margin: 0 0.125rem;
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2), 0 0 0 2px #fff inset;
  background-color: var(--BACKGROUND_LIGHT);
`;

export const SidebarWrapper = styled.div`
  width: 15rem;
  overflow: hidden;
`;

export const StyledHeaderText = styled(Text)`
  font-size: 1.125rem;
  font-family: ${props => props.theme.FONTS.semi_bold};
`;

export const StyledDivider = styled.div`
  border: 1px solid rgb(107, 99, 160);
  height: 2rem;
`;
